<template>
    <div class="create-campaign">

        <mu-form :model="form">

            <div class="steps">

                <!-- Step 1 | Mensagem -->
                <mu-form-campaign-step-message :activeStep="activeStep" step="1" title="Prepare a sua mensagem" :form="form" v-on:handleNext="handleNext"></mu-form-campaign-step-message>

                <!-- Step 2 | Contatos -->
                <mu-form-campaign-step-contacts-vars :activeStep="activeStep" step="2" title="Importar contatos e suas variáveis" :form="form" v-on:handleNext="handleNext" v-on:handlePrev="handlePrev"></mu-form-campaign-step-contacts-vars>

                <!-- Step 3 | Agendamento -->
                <mu-form-campaign-step-scheduling :activeStep="activeStep" step="3" title="Data e horário de execução" :form="form" v-on:handleNext="handleNext" v-on:handlePrev="handlePrev"></mu-form-campaign-step-scheduling>

                <!-- Step 4 | Confirmação -->
                <mu-form-campaign-step-conference :activeStep="activeStep" step="4" title="Conferência e confirmação da campanha" :form="form" v-on:handleNext="handleNext" v-on:handlePrev="handlePrev"></mu-form-campaign-step-conference>

                <!-- Step 5 - Finished -->
                <mu-form-campaign-step-finished :finished="finished"></mu-form-campaign-step-finished>

            </div>

        </mu-form>

    </div>
</template>

<script>
    export default {
        name: 'app-campaigns-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                activeStep: 1,
                form: {
                    for_client: false,
                    title: '',
                    cost_center: null,
                    type_message: null,
                    selected_type: 'new_message',
                    default_message: '',
                    default_message_description: '',
                    message: '',
                    selected_contacts: 'groups_contacts',
                    create_group: false,
                    totalcontacts: 0,
                    groups: [],
                    contacts: [],
                    inform_contacts: '',
                    send: 'now',
                    origin: 'app#',
                    schedule: {
                        date: undefined,
                        time: undefined
                    }
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Verifica se a campanha já finalizou
             */
            finished () {
                return this.activeStep > 4
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Volta um passo
             */
            handlePrev () {
                this.activeStep--
            },

            /**
             * Vai para o próximo passo utilizando o scrollTo para animação
             * e atualiza o form com os dados que vieram
             */
            handleNext (data) {
                this.form = data
                this.activeStep++
                setTimeout(() => {
                    this.$scrollTo('#step-' + this.activeStep, 500, { offset: -40 })
                }, 100)
            }
        }
    }
</script>

<style lang="stylus">

    @import './../../assets/stylus/bootstrap.styl'

    .mu-alert
        background #FDE6AB
        padding 5px 10px
        color #777

    .mu-dialog
        max-width 90% !important

    .steps

        .text-center
            text-align center

        .step
            max-width 700px
            margin auto

            .line
                width 1px
                height 40px
                border-left 1px #ccc solid
                margin auto
                margin-bottom 15px
                display block

            .number
                text-align center
                margin-top 15px
                padding 0
                font-size 15px
                color #999
                background lighten($grey, 40%)
                color #fff
                padding 5px 10px
                border-radius 20px
                width 34px
                height auto
                margin auto
                display block

            .title
                text-align center
                padding 3px 0
                font-size 12px
                color lighten($grey, 10%)

            .content
                display none
                padding 20px

                .d-flex
                    display block !important

                .group-radio-button
                    margin-bottom 10px

                    .mu-radio
                        margin 0 15px

            .buttons
                padding 20px 10px
                text-align center
                display none
                background lighten($grey, 85%)
                margin-bottom 20px

            &.active

                .title
                    color $primary
                    font-size 16px
                    padding 10px 0

                .number
                    background $primary
                    padding 10px 20px
                    border-radius 50px
                    font-size 20px
                    width 50px
                    height auto

                .content
                    display block

                .buttons
                    display block

    .create-campaign

        padding 30px 0

        .mu-button
            margin-right 10px

    // ------------------------------------------------------------------------------

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .mu-dialog
            max-width 75%

        .create-campaign

            .steps

                .step

                    .content

                        .d-flex
                            display flex

                        .header

                            .item
                                margin-bottom 0

</style>
